// extracted by mini-css-extract-plugin
module.exports = {"sticky":"StickyBar_sticky__1Oenx","hidden":"StickyBar_hidden__1n-6U"};